import * as Facebook from "./facebook";
import * as Instagram from "./instagram";
import * as YouTube from "./youtube";

const platformUtils = {
  Facebook,
  Instagram,
  YouTube,
};

export default platformUtils;
